"use client";

import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateCustomerProfile } from "../config/redux/slices/authAndAddressSlice";

/**
 * LastSourceTracker Component
 * 
 * This component tracks when a customer visits or refreshes the website
 * and updates their profile with lastSource = "WEB"
 * 
 * It runs once per page load/refresh when the user is authenticated,
 * and also when user logs in (token changes from null to a value).
 */
const LastSourceTracker = () => {
  const dispatch = useDispatch();
  const token = useSelector((state) => state.auth?.token);
  const prevTokenRef = useRef(null);
  const hasTrackedRef = useRef(false);

  useEffect(() => {
    // Check if token just became available (login happened)
    const tokenJustBecameAvailable = token && !prevTokenRef.current;
    
    // Update previous token ref
    prevTokenRef.current = token;

    // Track if user is authenticated and either:
    // 1. Token just became available (fresh login)
    // 2. Hasn't been tracked this session (page refresh with existing token)
    if (token && (tokenJustBecameAvailable || !hasTrackedRef.current)) {
      hasTrackedRef.current = true;
      
      // Update profile with source = "WEB"
      dispatch(updateCustomerProfile({ lastSource: "WEB" }))
        .unwrap()
        .then(() => {
        //   console.log("Source updated to WEB successfully");
        })
        .catch((error) => {
          console.error("Failed to update source:", error);
          // Reset the ref so it can try again if needed
          hasTrackedRef.current = false;
        });
    }
    
    // Reset tracking when user logs out
    if (!token) {
      hasTrackedRef.current = false;
    }
  }, [token, dispatch]);

  // This component doesn't render anything
  return null;
};

export default LastSourceTracker;
